module.exports = __webpack_public_path__ + "static/media/victoria_choi.890a0994.png";